import { Link } from 'react-router-dom';

import '../../libs/bulma.min.css';
import './PhoneCard.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare, faPenAlt, faPhone } from '@fortawesome/free-solid-svg-icons';

function PhoneCard(prop) {
 const { phones: { idpho, phonenumber, contactid }, changeVisibityMessages, setPhoneModify, setIidModPhone, del, handleClickToCall } = prop;

  return (
    <div className="phone-card">
      <div className="phone-card-header">
        <div className="phone-number">
          <svg className="phone-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
          </svg>
          <span className="phone-number-text">
            { phonenumber &&  Number(phonenumber.split('')[0]) === 8 ? '0' + phonenumber : phonenumber }
          </span>
        </div>
        <button className="btn-call" aria-label="Fazer ligação" onClick={ () => handleClickToCall(phonenumber) }>
          <FontAwesomeIcon icon={ faPhone } fixedWidth />
        </button>
      </div>
      <div className="phone-card-footer">
        <button className="phone-action-btn btn-edit-phone" onClick={ () => {
          setPhoneModify({ idpho, phonenumber })
          setIidModPhone(idpho)
          changeVisibityMessages(true, 'buttons-edit-contact');
          changeVisibityMessages(true, 'list-phones');
          changeVisibityMessages(false, 'input-edit-phone');
        } }>
          <FontAwesomeIcon icon={ faPenAlt } fixedWidth />
          <span>Editar</span>
        </button>
        <button 
          name={ `delete-phone-link-${idpho}` } 
          className="phone-action-btn btn-delete-phone" 
          onClick={ () => {
            changeVisibityMessages(true, `delete-phone-link-${idpho}`);
            changeVisibityMessages(false, `delete-phone-confirm-${idpho}`);
          } }
        >
          Excluir
        </button>
        <button 
          name={ `delete-phone-confirm-${idpho}` } 
          className="phone-action-btn btn-confirm-delete is-hidden" 
          onClick={ () => { del({ value: idpho, phone: phonenumber }) } }
        >
          Confirmar
        </button>
      </div>
    </div>
  )
}

export default PhoneCard;
